/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetAllPackagingUnitIdEanPairs$Params {

/**
 * UUID of the merchant site to retrieve EAN mappings for
 */
  siteId: string;
}

export function getAllPackagingUnitIdEanPairs(http: HttpClient, rootUrl: string, params: GetAllPackagingUnitIdEanPairs$Params, context?: HttpContext): Observable<StrictHttpResponse<{
[key: string]: Array<string>;
}>> {
  const rb = new RequestBuilder(rootUrl, getAllPackagingUnitIdEanPairs.PATH, 'get');
  if (params) {
    rb.path('siteId', params.siteId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      [key: string]: Array<string>;
      }>;
    })
  );
}

getAllPackagingUnitIdEanPairs.PATH = '/site/{siteId}/products/ids-by-ean';
